import { useState } from "react";

const links = [
  { label: "直达入口", href: "#jieru" },
  { label: "今日热议", href: "#reyi" },
  { label: "围观指南", href: "#zhinan" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜路线首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold leading-none text-foreground-900">
            吃瓜<span className="text-primary-600">路线</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#jieru"
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-flashlight-line text-base" aria-hidden="true"></i>
            马上围观
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 hover:bg-background-200/70 md:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-[15px] text-foreground-800 hover:bg-background-200/70"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#jieru"
              onClick={() => setOpen(false)}
              className="mt-1 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg bg-primary-500 px-3 py-2.5 text-[15px] font-medium text-background-50"
            >
              <i className="ri-flashlight-line" aria-hidden="true"></i>
              马上围观
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}